import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46898 14.523l1.354 1.372c.699.698 1.80802.789 2.60302.203 1.781-1.315 3.357-2.89 4.671-4.671.587-.795.496-1.905-.203-2.603l-1.445-1.239C15.39 6.156 16.182 4.62 16.804 3l1.746.437c1.748.437 2.757 2.321 2.073 3.988-.579 1.41-1.289 2.753-2.11 4.018l.014.013c-1.836 2.824-4.247 5.236-7.071 7.071l-.014-.013c-1.264.821-2.60702 1.531-4.01802 2.11-1.667.684-3.551-.325-3.988-2.073l-.436-1.746c1.577-.606 3.073-1.373 4.469-2.282z",
    fill: "currentColor"
  }));
});